var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConference(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1137_1444",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1137_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 26.25C19.3125 26.25 18.724 26.0052 18.2344 25.5156C17.7448 25.026 17.5 24.4375 17.5 23.75V18.75C17.5 18.0625 17.7448 17.474 18.2344 16.9844C18.724 16.4948 19.3125 16.25 20 16.25H25C25.6875 16.25 26.276 16.4948 26.7656 16.9844C27.2552 17.474 27.5 18.0625 27.5 18.75V23.75C27.5 24.4375 27.2552 25.026 26.7656 25.5156C26.276 26.0052 25.6875 26.25 25 26.25H20ZM20 23.75H25V18.75H20V23.75ZM2.5 22.5V20H13.75V22.5H2.5ZM20 13.75C19.3125 13.75 18.724 13.5052 18.2344 13.0156C17.7448 12.526 17.5 11.9375 17.5 11.25V6.25C17.5 5.5625 17.7448 4.97396 18.2344 4.48438C18.724 3.99479 19.3125 3.75 20 3.75H25C25.6875 3.75 26.276 3.99479 26.7656 4.48438C27.2552 4.97396 27.5 5.5625 27.5 6.25V11.25C27.5 11.9375 27.2552 12.526 26.7656 13.0156C26.276 13.5052 25.6875 13.75 25 13.75H20ZM20 11.25H25V6.25H20V11.25ZM2.5 10V7.5H13.75V10H2.5Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConference);
export default __webpack_public_path__ + "static/media/conference.d1a4e1686e15e86689e3bcfc2c668f70.svg";
export { ForwardRef as ReactComponent };